import { Outlet } from "react-router";
import { LocationPermissionProvider } from "@/hooks/use-location-permission";
import { FavoritesProvider } from "@/hooks/useFavorites";

/**
 * Top-level layout that owns the app-wide location permission and Favorites
 * contexts. Favorites live here so every surface shares one list, resolved
 * once per app load (docs/adr/0008).
 *
 * The provider lives here — above both the full-screen Location Landing
 * (`/`, no tab shell) and the tab app (wrapped in <TabLayout>) — so a single
 * permission state machine is shared across the two surfaces. A grant on the
 * landing flips `hasCompletedFlow`, and the tab app sees that same value the
 * instant the landing redirects onward. Renders nothing of its own beyond the
 * matched child route via <Outlet>.
 */
export default function RootLayout() {
  return (
    <LocationPermissionProvider>
      <FavoritesProvider>
        <Outlet />
      </FavoritesProvider>
    </LocationPermissionProvider>
  );
}
